import '@angular/localize/init';
export * from './lib/feature-tax-corporate-list.module';
export * from './lib/tax-corporate-list/feature-tax-corporate-list.component';
